import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { VectorClickedElementType } from '../../components/Vector/types/vectorDataChartTypes';
import { setVectorClickedItemType } from '../../reducers/vectorConfigurationSlice';

/** Used to set which vector element is clicked (ex. Device icon, Critical alarms number)
 * since each of these components is on different levels across the application,
 * They need to know when one of them is being clicked in order for the others to remove their active classes
 */
const useVectorClickedElement = (
  vectorClickedItem: VectorClickedElementType,
) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setVectorClickedItemType(vectorClickedItem));
  }, []);
};

export default useVectorClickedElement;
